<template>
  <div class="popUpWrap">
    <section class="popup dark fileReset">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="popupInfo">
        <div class="titleArea">
          <div class="icon"></div>
          <h5>{{ t("learning-reset-select-files") }}</h5>
        </div>
        <div class="lectureDirectory scrollBar">
          <div class="directoryWrap">
            <LazyLearningDirectoryRollbackPopupDirectory
                v-if="learningStore.directory.modifiedFiles.length > 0"
                path=""
                name="Directory"
                :tree-item="learningStore.directory.rollbackTree"
            />
          </div>
        </div>
        <div class="btnArea">
          <button :class="{disabled: !isActiveRollback}" @click.stop="onClickConfirm">
            {{ t("common-reset") }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useRoute} from "vue-router";
import {useDialogStore} from "~/store/dialog/dialogStore";
import {convertToNextLine, useI18n} from "#imports";
import {useLearningStore} from "~/store/learning/learningStore";
import {useLearningDirectoryService} from "~/composables/service/useLearningDirectoryService";
import {useToastStore} from "~/store/toast/toastStore";
import {ToastType} from "~/components/Common/Toast/model/ToastType";
import {useUserStore} from "~/store/user/userStore";

const { t } = useI18n();

const toastStore = useToastStore();
const dialogStore = useDialogStore();
const learningStore = useLearningStore();
const userStore = useUserStore();
const route = useRoute();

const isActiveRollback = computed(() => learningStore.directory.rollbackPathList.length > 0)

onMounted(() => {
  learningStore.directory.rollbackPathList = []
  useLearningDirectoryService().getModifiedFiles();
})

const onClickClose = () => {
  learningStore.directory.rollbackTree = {}
  learningStore.directory.rollbackPathList = []
  dialogStore.options.close?.event()
  dialogStore.close()
}

const onClickConfirm = () => {
  if(!isActiveRollback.value) return;

  const currentModifiedFiles = [...learningStore.directory.modifiedFiles];

  learningStore.directory.rollbackPathList.forEach(rollbackPath => {
    learningStore.directory.modifiedFiles = learningStore.directory.modifiedFiles.filter
    (modifiedFile => modifiedFile.path !== ("/" + rollbackPath))
  });

  useLearningDirectoryService().rollbackFiles({
    directoryType: learningStore.getUserLearningDirectoryType,
    taskId: learningStore.task.id,
    userUuid: userStore.userV2.uuid,
    domainId: learningStore.getDomainId,
    isSubmission: true,
    isSaving: true,
  },(isSuccess) => {
    if (isSuccess)
      toastStore.openToast({
        toastType: ToastType.SUCCESS,
        contents: t("learning-reset-select-files-success"),
      });
    else {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: convertToNextLine(t("learning-reset-select-files-fail")),
      });
      learningStore.directory.modifiedFiles = [...currentModifiedFiles];
    }
    onClickClose();
  });
}
</script>

